import { getField } from "vuex-map-fields";
export default {
  getParticipantField(state) {
    return getField(state.participants);
  },
  getAllField(state) {
    return getField(state);
  }
};
